export default {
  ICON_PATH: '/icons/'
}
